function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.6667 21.6666C18.6667 22.7275 18.2452 23.7449 17.4951 24.495C16.7449 25.2452 15.7275 25.6666 14.6667 25.6666H5.33333C4.27247 25.6666 3.25505 25.2452 2.50491 24.495C1.75476 23.7449 1.33333 22.7275 1.33333 21.6666V5.66659H0V1.66659H6L7.33333 0.333252H12.6667L14 1.66659H20V5.66659H18.6667V21.6666ZM2.66667 5.66659V21.6666C2.66667 22.3738 2.94762 23.0521 3.44772 23.5522C3.94781 24.0523 4.62609 24.3333 5.33333 24.3333H14.6667C15.3739 24.3333 16.0522 24.0523 16.5523 23.5522C17.0524 23.0521 17.3333 22.3738 17.3333 21.6666V5.66659H2.66667ZM18.6667 4.33325V2.99992H13.3333L12 1.66659H8L6.66667 2.99992H1.33333V4.33325H18.6667ZM5.33333 8.33325H6.66667V21.6666H5.33333V8.33325ZM13.3333 8.33325H14.6667V21.6666H13.3333V8.33325Z",
  fill: "white"
});
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete_icon.9093e6d872347f2187673b7eca723c46.svg";
export { ForwardRef as ReactComponent };